











































































































import { PublicCourseDetails } from '@/jbi-shared/dto/jtms-public-course.dtos';
import { CourseLocation } from '@/jbi-shared/types/jtms.types';
import { formatDateTime } from '@/jbi-shared/util/group-level-attributes.util';
import BaseDivider from '@/jbi-shared/vue-components/BaseDivider.vue';
import { RootState } from '@/store/store';
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import EventHeader from './components/EventHeader.vue';
import GenericInformationComponent from './components/GenericInformationComponent.vue';
import ContentBlock from './layout/ContentBlock.vue';

@Component({
  components: {
    BaseDivider,
    EventHeader,
    GenericInformationComponent,
    ContentBlock
  }
})
export default class CourseInformation extends Vue {
  @State(({ course }: RootState) => course.publicCourseState.courseDetails)
  public publicCourseDetails!: PublicCourseDetails;

  get isRemote(): boolean {
    return this.publicCourseDetails.locationType === CourseLocation.REMOTE;
  }

  get description(): string {
    if (!this.publicCourseDetails.courseDescription) {
      return 'No description provided.';
    }

    return this.publicCourseDetails.courseDescription;
  }

  get programDetails(): string {
    if (this.publicCourseDetails.nonDefaultDetails) {
      // TODO: Develop mechanism to retrieve keys dynamically based on the Required GLA template
      const details = this.publicCourseDetails.nonDefaultDetails;
      if (
        details['program-details'] &&
        typeof details['program-details'] === 'string'
      ) {
        return details['program-details'] as string;
      }
    }

    return '<p>No program details provided.</p>';
  }

  get registrationCloseDate(): string {
    if (this.publicCourseDetails.nonDefaultDetails) {
      // TODO: Develop mechanism to retrieve keys dynamically based on the Required GLA template
      const details = this.publicCourseDetails.nonDefaultDetails;
      if (
        details['registration-close-date'] &&
        typeof details['registration-close-date'] === 'string'
      ) {
        const closeDateString = details['registration-close-date'] as string;
        const formatteddDate: string = formatDateTime(
          new Date(closeDateString)
        );

        return `${formatteddDate} (unless sold out prior)`;
      }
    }

    return 'No registration close date provided.';
  }

  get trainers(): string[] {
    if (!this.publicCourseDetails.trainers) {
      return [];
    }

    return this.publicCourseDetails.trainers
      .split(', ')
      .map((val) => val.trim());
  }
}
